import React from 'react'
import { Container, Col, Row, Image } from "react-bootstrap";
import Abtone from '../../../Assets/images/cultbrilliance/wearehere.jpg'
import Abtwo from '../../../Assets/images/cultbrilliance/weareheretwojpg.jpg'
import Abthree from '../../../Assets/images/cultbrilliance/weareherethreejpg.jpg'
import Abtfour from '../../../Assets/images/cultbrilliance/weareherefourjpg.jpg'
const Ourshowroom = () => {
  return (
    <>
     <section className="cbr_aboutus_page">
      <Container>
        <h2 className="text-center">Our Showroom</h2>
        <div className="cbr_our_showrrom">  
        <Row className="cbr_abtfirst_row">
          <Col md={6} sm={12} lg={6}>
            <div className="cbr_weareher">
              <img src={Abtone} alt="Our Showroom" className="img-fluid" />
            </div>
          </Col>
          <Col md={6} sm={12} lg={6}>
            <div className="cbr_weareher">
              <img src={Abtwo} alt="Our Showroom" className="img-fluid" />
            </div>
          </Col>
          </Row>
          <Row className="cbr_abtsecond_row">
          <Col md={6} sm={12} lg={6}>
            <div className="cbr_weareher">
              <img src={Abthree} alt="Our Showroom" className="img-fluid" />
            </div>
          </Col>
          <Col md={6} sm={12} lg={6}>
            <div className="cbr_weareher">
              <img src={Abtfour} alt="Our Showroom" className="img-fluid" />
            </div>
          </Col>
          </Row>
          </div>
      </Container>
      </section>
    </>
  )
}

export default Ourshowroom
